import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import './Pack.css';

const Pack = (props) => {

  const packsReduxStore = useSelector(state => {
    return state.packs;
  });

  let { packID } = useParams();

  let [packData, setPackData] = useState(undefined);

  useEffect(
    () => {
      fetchPack();
    },
    [] // no state params, only running once
  );  

  const fetchPack = async () => {
    if (!packsReduxStore.hasOwnProperty(packID)) {
      return;
    }
    setPackData(packsReduxStore[packID]);
  }

  return (
    <div className="pack">
      <header className="sectionLanding">
        <div className="sectionLandingContentWrapper">
          <div className="sectionLandingLeft">
            <h1>
              {packsReduxStore[packID] ?
                packsReduxStore[packID].title
              :
                null
              }
            </h1>
            <h2>
              {packsReduxStore[packID] ?
                packsReduxStore[packID].description
              :
                null
              }
            </h2>
          </div>
          <div className="sectionLandingRight">
            {packsReduxStore[packID] ?
              <img src={packsReduxStore[packID].imageURL} />
            :
              null
            }
          </div>
        </div>
      </header>
      <div className="sectionSeparator brand-secondary"></div>
      <section className="packSection">
        
      </section>
    </div>
  );
}

export default Pack;